import React from "react"

interface JobProgressSummary {
	total: number
	queued: number
	inProgress: number
	succeeded: number
	failed: number
}

interface JobProgressPanelProps {
	jobProgress: {summary: JobProgressSummary}
	onStopMonitoring: () => void
}

export const JobProgressPanel: React.FC<JobProgressPanelProps> = ({
	jobProgress,
	onStopMonitoring,
}) => {
	return (
		<div className="bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-lg p-4 mb-4">
			<div className="flex items-center justify-between mb-2">
				<h3 className="font-semibold text-blue-900 dark:text-blue-200">
					Upload Progress (Auto-refreshing every 5s)
				</h3>
				<button
					onClick={onStopMonitoring}
					className="text-blue-600 dark:text-blue-400 hover:text-blue-800 dark:hover:text-blue-200 text-sm">
					Stop Monitoring
				</button>
			</div>
			<div className="grid grid-cols-5 gap-2 text-sm">
				<div>
					<span className="text-gray-600 dark:text-gray-400">Total:</span>{" "}
					<span className="dark:text-gray-200">{jobProgress.summary.total}</span>
				</div>
				<div>
					<span className="text-gray-600 dark:text-gray-400">Queued:</span>{" "}
					<span className="dark:text-gray-200">{jobProgress.summary.queued}</span>
				</div>
				<div>
					<span className="text-gray-600 dark:text-gray-400">In Progress:</span>{" "}
					<span className="dark:text-gray-200">{jobProgress.summary.inProgress}</span>
				</div>
				<div>
					<span className="text-green-600 dark:text-green-400">Succeeded:</span>{" "}
					<span className="dark:text-green-300">{jobProgress.summary.succeeded}</span>
				</div>
				<div>
					<span className="text-red-600 dark:text-red-400">Failed:</span>{" "}
					<span className="dark:text-red-300">{jobProgress.summary.failed}</span>
				</div>
			</div>
		</div>
	)
}

export default JobProgressPanel
